export const isInViewport = (DOMElement) => {
    const rect = DOMElement.getBoundingClientRect();

    return window.innerHeight - rect.top > 0 && rect.bottom > 0;
};

export const isBelowViewport = (DOMElement) => {
    const rect = DOMElement.getBoundingClientRect();

    // console.log(rect, window.innerHeight);

    return rect.bottom > 0;
};

// Arrow function to check if scroll is at the end of the page
export const isScrollAtEnd = () =>
    // window.scrollY gives the current vertical scroll position
    // window.innerHeight gives the height of the viewport
    // document.documentElement.scrollHeight represents the total scrollable height of the document
    // If the sum of window.innerHeight and window.scrollY is close to or equal to document.documentElement.scrollHeight
    // Then the scroll is at the end of the page
    window.scrollY + window.innerHeight >= document.documentElement.scrollHeight;
